import { Container, Row } from "reactstrap";
import { BasicTables, ReactstrapTitle } from "../../../../../constants";
import BasicTableWithBorder from "./BasicTableWithBorder";
import BreckpointSpecific from "./BreckpointSpecific";
import CaptionTable from "./CaptionTable";
import CustomColorHoverStripped from "./CustomColorHoverStripped";
import DashedBorder from "./DashedBorder";
import HoverableRows from "./HoverableRows";
import InverseTable from "./InverseTable";
import InverseTablePrimary from "./InverseTablePrimary";
import ResponsiveLightBackground from "./ResponsiveLightBackground";
import SizingTables from "./SizingTables";
import StripedRowInverseTable from "./StripedRowInverseTable";
import TableHeadOptions from "./TableHeadOptions";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const BasicTableContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={BasicTables} parent={ReactstrapTitle} />
      <Container className="basic_table" fluid>
        <Row>
          <BasicTableWithBorder />
          <InverseTable />
          <HoverableRows />
          <InverseTablePrimary />
          <CaptionTable />
          <TableHeadOptions />
          <StripedRowInverseTable />
          <BreckpointSpecific />
          <ResponsiveLightBackground />
          <SizingTables />
          <CustomColorHoverStripped />
          <DashedBorder />
        </Row>
      </Container>
    </>
  );
};

export default BasicTableContainer;
